import { Icon } from '@innovationnorway/cl-react';
import React from 'react';
import '../../styles/OneWayInStyle.scss';
import { OneWayInFeedbackUpsertDto } from 'src/api/v2';
import { useTranslation } from 'react-i18next';
import { Tabs } from '@innovationnorway/cl-react';
import OpportunityFeedback from './OpportunityFeedback';
import { RaskAvklaringViser } from '@innovationnorway/kunde-raskavklaring-visning';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import useOneWayInReview from '../../hooks/use-one-way-in-review';
import { formatDateToNOString } from 'src/utils/FormatValue';
import HistoryViewEmailContent from '../../opportunity-details/components/history/HistoryViewEmailContent';
import { sanitizeMinSideEmail } from '../../utils/htmlTextConverter';
import useOneWayInFeedback from '../../hooks/use-one-way-in-feedback';
import OpportunityFeedbackOtherActorsList from './OpportunityFeedbackOtherActorsList';
import '../../../../styles/style.scss';
import { FeedbackObject, ReviewDto } from './OneWayInReviewOpportunities';
import useGeonorge from '../../hooks/use-geonorge';
type Props = {
  opportunity: ReviewDto;
};
type TabTypes = 'form' | 'mail' | 'other-feedbacks';
const StatusIcon = ({ feedback }: { feedback: FeedbackObject | undefined }) => {
  if (feedback?.wasCorrectlyReferred === true)
    return <Icon prefix="fasr" iconName="check-circle" size="l" color="#2fcc72" />;
  if (feedback?.wasCorrectlyReferred === false)
    return <Icon prefix="fasr" iconName="times" size="l" color="#ed0000" />;
  return <Icon prefix="fasr" iconName="square-info" size="l" />;
};
const OneWayInReviewListItem: React.FC<Props> = ({ opportunity }) => {
  const { t: tOneWayIn } = useTranslation('oneWayIn');
  const [showFeedback, setShowFeedback] = React.useState<boolean>(false);
  const {
    oneWayInReviewGroupedFormQuery,
    oneWayInGroupedFormEnrollment,
    onewWayInOpportunityFormINResponseMailQuery,
  } = useOneWayInReview(showFeedback ? opportunity.id : undefined);
  const { opportunityFeedbackCollection, upsertMutation, isFetching } = useOneWayInFeedback(
    showFeedback ? opportunity.id : undefined,
  );
  const { getMunicipalityNameByNumber } = useGeonorge();
  const municipalityName = React.useMemo(() => {
    if (opportunity.prosjektKommune) {
      return getMunicipalityNameByNumber(opportunity.prosjektKommune);
    }
    return '';
  }, [opportunity.prosjektKommune, getMunicipalityNameByNumber]);
  const [tab, setTab] = React.useState<TabTypes>('form');
  const onShowFeedbackClick = () => {
    setShowFeedback((prevValue) => !prevValue);
  };
  const onFeedbackSave = (feedbackUpsertDto: OneWayInFeedbackUpsertDto) => {
    upsertMutation.mutate(feedbackUpsertDto);
  };
  const form = React.useMemo(() => {
    if (!oneWayInReviewGroupedFormQuery.data) {
      return undefined;
    }
    const data = oneWayInReviewGroupedFormQuery.data;
    if (oneWayInGroupedFormEnrollment.data) {
      if (!data.grupper) data.grupper = [];
      data.grupper.push(oneWayInGroupedFormEnrollment.data);
    }
    return data;
  }, [oneWayInReviewGroupedFormQuery.data, oneWayInGroupedFormEnrollment.data]);
  return (
    <div className="opportunity-card margin-top--2 display--flex flex-direction--column">
      <button
        className="display--flex flex-direction--row cursor--pointer clickable-wrapper item-wrapper"
        onClick={onShowFeedbackClick}
      >
        <div className="display--flex align-items--center">
          <div className="margin-right--4">
            <StatusIcon feedback={opportunity.feedback} />
          </div>
        </div>
        <div className="display--flex flex-direction--column flex--2">
          <div className="display--flex align-items--center margin-bottom--1">
            <div className="opportunity-card__municipality-name">
              {opportunity.insendtDato &&
                formatDateToNOString(opportunity.insendtDato, false, '{date}.{month}.{year}', true)}
            </div>
          </div>
          <div className="display--flex align-items--center margin-bottom--1">
            <div className="opportunity-card__municipality-name">{municipalityName}</div>
          </div>
          <div className="display--flex">
            <div className="flex--2 opportunity-card__title">
              <span>{opportunity.tittel}</span>
            </div>
            <div>
              <Icon prefix="fasr" iconName={showFeedback ? 'chevron-up' : 'chevron-down'} />
            </div>
          </div>
          <div className="display--flex align-items--center margin-bottom--1">
            {opportunity.recipients && (
              <div className="opportunity-card__municipality-name">{`${tOneWayIn('sentTo')}: ${opportunity.recipients.join(', ')}`}</div>
            )}
          </div>
          {opportunity.feedback?.comment && (
            <div className="margin-top--2 margin-bottom--2">{opportunity.feedback.comment}</div>
          )}
        </div>
      </button>
      <div>
        {showFeedback && (
          <div>
            <div className="margin-top--1 margin-bottom--4">
              <OpportunityFeedback
                opportunityId={opportunity.id!}
                opportunityTitle={opportunity.tittel || ''}
                opportunityMunicipality={opportunity.prosjektKommune}
                opportunityCounty={opportunity.county}
                actorFeedback={opportunityFeedbackCollection?.actorFeedback}
                isFetching={upsertMutation.isLoading || isFetching}
                onSave={onFeedbackSave}
              />
            </div>
            <div className="margin-bottom--4">
              <Tabs value={tab}>
                <Tabs.List>
                  <Tabs.Tab value="form" onClick={() => setTab('form')} aria-label={tOneWayIn('tab.Form')}>
                    {tOneWayIn('tab.Form')}
                  </Tabs.Tab>
                  <Tabs.Tab
                    value="mail"
                    onClick={() => setTab('mail')}
                    aria-label={tOneWayIn('tab.INResponseMail')}
                  >
                    {tOneWayIn('tab.INResponseMail')}
                  </Tabs.Tab>
                  <Tabs.Tab
                    value="other-feedbacks"
                    onClick={() => setTab('other-feedbacks')}
                    aria-label={tOneWayIn('feedbackFromOtherActors')}
                  >
                    {tOneWayIn('feedbackFromOtherActors')}
                  </Tabs.Tab>
                </Tabs.List>
              </Tabs>
            </div>
            {tab === 'form' && (
              <>
                {oneWayInReviewGroupedFormQuery.isFetching ||
                  (oneWayInGroupedFormEnrollment.isFetching && <LoadingPage />)}
                {form &&
                  !oneWayInReviewGroupedFormQuery.isFetching &&
                  !oneWayInGroupedFormEnrollment.isFetching && (
                    <RaskAvklaringViser
                      id={form?.id ?? ''}
                      tittel={form.tittel ?? ''}
                      grupper={form?.grupper ?? []}
                      organisasjon={{
                        navn: form?.organisasjon?.navn ?? '',
                        erPerson: form?.organisasjon?.erPerson ?? false,
                        etableringsDato: form?.organisasjon?.etableringsDato ?? '',
                        bedriftsAlder: form?.organisasjon?.bedriftsAlder ?? '',
                        kommune: form?.organisasjon?.kommune ?? '',
                        antallAnsatte: form?.organisasjon?.antallAnsatte?.toString() ?? '',
                      }}
                      kontakt={{
                        navn: form?.kontakt?.navn ?? '',
                      }}
                      innsendtDato={form.innsendtDato || ''}
                    />
                  )}
              </>
            )}
            {tab === 'mail' && (
              <>
                {onewWayInOpportunityFormINResponseMailQuery.isLoading && <LoadingPage />}
                {!onewWayInOpportunityFormINResponseMailQuery.isLoading &&
                  onewWayInOpportunityFormINResponseMailQuery.isError && (
                    <div>{tOneWayIn('errorINResponse')}</div>
                  )}
                {onewWayInOpportunityFormINResponseMailQuery.data && (
                  <section>
                    <HistoryViewEmailContent
                      from={onewWayInOpportunityFormINResponseMailQuery.data?.sender?.emailAddress || ''}
                      to={onewWayInOpportunityFormINResponseMailQuery.data?.recipient?.emailAddress || ''}
                      date={formatDateToNOString(
                        onewWayInOpportunityFormINResponseMailQuery.data.createdOn || new Date(),
                        false,
                        '{date}.{month}.{year}',
                        true,
                      )}
                      content={
                        <div
                          dangerouslySetInnerHTML={{
                            __html: sanitizeMinSideEmail(
                              onewWayInOpportunityFormINResponseMailQuery.data?.body || '',
                            ),
                          }}
                        />
                      }
                    />
                  </section>
                )}
              </>
            )}
            {tab === 'other-feedbacks' && (
              <OpportunityFeedbackOtherActorsList
                feedbackList={opportunityFeedbackCollection?.otherFeedbacks || []}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default OneWayInReviewListItem;
